export default __webpack_public_path__ + "static/16-d237a1058c0c292a07ac99b6c5ffba22.webp";